import React from "react";
import { motion } from "framer-motion";
import { Star, Users, Home, Globe, Camera, Video } from "lucide-react";

const KIND = {
  reputation: { Icon: Star, color: "#5F8213", bg: "rgba(147,192,32,.12)" },
  competitor: { Icon: Users, color: "#A9781F", bg: "rgba(229,169,61,.14)" },
  property: { Icon: Home, color: "#3E7CB1", bg: "rgba(62,124,177,.10)" },
  website: { Icon: Globe, color: "#7A5AF0", bg: "rgba(122,90,240,.10)" },
  social: { Icon: Video, color: "#5F8213", bg: "rgba(147,192,32,.12)" },
};

export default function IntelligenceFeed({ items = [] }) {
  if (!items.length) return null;
  return (
    <div className="card p-6 sm:p-7" data-testid="intelligence-feed">
      <div className="flex items-center gap-2 mb-1">
        <span className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ background: "#93C020" }} />
        <h2 className="text-xl font-bold tracking-tight text-ink">Growth intelligence feed</h2>
      </div>
      <p className="text-sm text-ink-2 mb-5">What Growth found while you were away.</p>
      <div className="relative pl-6">
        <div className="absolute left-[7px] top-1 bottom-1 w-px" style={{ background: "#EDEEE9" }} />
        <div className="space-y-5">
          {items.map((it, i) => {
            const k = KIND[it.kind] || KIND.social;
            const Icon = k.Icon;
            return (
              <motion.div key={i} initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.05 }}
                className="relative" data-testid={`feed-item-${i}`}>
                <span className="absolute -left-6 top-0.5 grid place-items-center w-4 h-4 rounded-full ring-4 ring-white" style={{ background: k.color }} />
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="label-caps">{it.when}</span>
                  {it.impact && <span className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold" style={{ background: k.bg, color: k.color }}>{it.impact}</span>}
                </div>
                <p className="font-semibold text-ink mt-1 leading-snug">{it.title}</p>
                <p className="text-sm text-ink-2 mt-0.5 leading-relaxed">{it.detail}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
